import { FeatureCandidateGoods } from './vo/feature-candidate-goods.model';
import { FeatureRequest } from './vo/feature-request.model';
import { RequestBuyer } from './vo/request-buyer.model';
import { ClassCode } from './vo/class-code.model';
import { MediumType } from './vo/medium-type.model';
import { UpdateFeatureRequestBuyer } from './vo/update-feature-request-buyer.model';

/**
 * 表紙・特集商品選定依頼確認（グループ長用）画面の値を管理するクラス
 *
 * @export KYMW7006Model
 * @class KYMW7006Model
 */
export class KYMW7006Model {
  // 受注コード
  public orderCode: string = '';

  // 一覧取得成功時の受注コード
  public displaySucceededOrderCode: string = '';

  // 企画回
  public catalogId: string = '';

  // 媒体リスト
  public mediumTypeList: MediumType[] = [];

  // 媒体
  public mediumType: string = '';

  // 一覧取得成功時の媒体
  public displaySucceededMediumType: string = '';

  // 部門リスト
  public classCodeList: ClassCode[] = [];

  // 部門
  public classCode: string = '';

  // 特集コード
  public featureCode: string = '';

  // 特集候補商品一覧
  public featureCandidateGoodsList: FeatureCandidateGoods[] = [];

  // 依頼一覧
  public featureRequestList: FeatureRequest[] = [];

  // 依頼先バイヤー
  public requestBuyer: RequestBuyer[] = [];

  // 特集候補商品一覧情報更新
  public updateFeatureRequestBuyer: UpdateFeatureRequestBuyer[] = [];

  // ログインユーザーID
  public loginUserId: string = '';

  /**
   * 計画供給高から計画供給高（千円）の変換
   * @param planSupplyBudget 
   */
  public setDispPlanSupplyBudget(planSupplyBudget: any): string {
    let retValue = 0;
    retValue = Math.round(Number(planSupplyBudget) * 0.001);
    return String(retValue);
  }
}
